import sdl from '@jds/react-generated-sdl/JDSDropdownMenuSubMenu';
import type { JDSDropdownMenuSubMenuProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSDropdownMenuSubMenuProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { custom = '', ...rest } = props as any;
  return createComponent(
    json,
    rest,
    'JDSDropdownMenuSubMenu',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const DropdownMenuSubMenu = withLogic(
  Component
) as React.FC<JDSDropdownMenuSubMenuProps> & { slotName?: string };

DropdownMenuSubMenu.displayName = 'DropdownMenuSubMenu';
DropdownMenuSubMenu.slotName = 'jds_dropdown_menu_sub_menu';

export { DropdownMenuSubMenu, type JDSDropdownMenuSubMenuProps };
